import get from 'lodash/get';
$ const title = get(state, 'title', '');
$ const price = get(state, 'price', '');
$ const imageURL = get(state, 'imageURL', "");
<div class="item-card">
  <div class="item-card__image">
    <if(imageURL)>
      <img src=imageURL alt=title>
    </if>
    <else>
      <ebay-image-placeholder/>
    </else>
  </div>
  <div class="item-card__item-details">
    <if(title)>
      <span class="item-card__item-details__title">
        ${title}
      </span>
    </if>
    <if(price)>
      <span class="item-card__item-details__price" aria-live="polite">
        ${price}
      </span>
    </if>
  </div>
</div>